// extracted by mini-css-extract-plugin
export default {"icon":"FooterButtonsComponent_icon__WcLHh","iconPlus":"FooterButtonsComponent_iconPlus__HRvS1","footerButtons":"FooterButtonsComponent_footerButtons__KExsZ"};